import { useSelector } from 'react-redux'
import { isWebviewSelector } from 'selectors'
import { sendNativeMessage } from 'util/native'
import { Button } from 'roadie-ui'

type Email = {
  to: string
  subject: string
  body: string
}

type LinkProps = {
  email?: Email
  href: string
  children: React.ReactNode
}

const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

function buildMailTo(email: Email) {
  return `mailto:${email.to}?subject=${encodeURIComponent(email.subject)}&body=${encodeURIComponent(email.body)}`
}

export const ExternalLink = (props: LinkProps) => {
  const { email, href, children, ...otherProps } = props
  const { isWebview } = useSelector(isWebviewSelector)

  const isEmail = email || (href && href.startsWith('mailto'))

  if (iOS && isWebview) {
    const handleClick = () => {
      if (email) {
        sendNativeMessage({
          type: 'SEND_EMAIL',
          email: {
            to: email.to,
            subject: email.subject,
            body: email.body,
          },
        })
      } else {
        sendNativeMessage({
          type: 'LINK_CLICK',
          href,
        })
      }
    }
    return (
      <Button.Div.Tertiary onClick={handleClick} $textTransform="none" {...otherProps}>
        {children}
      </Button.Div.Tertiary>
    )
  } else {
    return (
      <Button.A.Tertiary
        target={isWebview && isEmail ? '' : '_blank'}
        rel="noopener noreferrer"
        href={email ? buildMailTo(email) : href}
        $textTransform="none"
        {...otherProps}
      >
        {children}
      </Button.A.Tertiary>
    )
  }
}

export default ExternalLink
